import formTemplates from './formTemplates';

export function state() {
  return {
    formData: new Map(formTemplates),
  };
}
